import { render } from "./Incentives.vue?vue&type=template&id=33c2495e&scoped=true&ts=true"
import script from "./Incentives.ts?vue&type=script&lang=ts&external"
export * from "./Incentives.ts?vue&type=script&lang=ts&external"

import "./Incentives.scss?vue&type=style&index=0&id=33c2495e&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c2495e"]])

export default __exports__